import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { reorderColumnsWithPrintAtTheEnd } from './utils';

const initialState = {};

const reducerMap = {
	[types.SET_CAMPAIGN_DETAIL]: (state, { payload }) => {
		return payload.detail;
	},
	[types.ADD_CONTACT_DATA_COLUMN]: (state, { payload }) => {
		return {
			...state,
			contactDataColumns: reorderColumnsWithPrintAtTheEnd([...(state.contactDataColumns || []), payload.column]),
		};
	},
	[types.REMOVE_CONTACT_DATA_COLUMN]: (state, { payload }) => {
		return {
			...state,
			contactDataColumns: state.contactDataColumns.filter((column) => column !== payload.column),
		};
	},
};
export default handleActions(reducerMap, initialState);
